// extracted by mini-css-extract-plugin
export default {"progressContainer":"styles__progressContainer__63hgK","progressRingPlaceholder":"styles__progressRingPlaceholder__c88KO","shimmer":"styles__shimmer__sVs73"};